import { useQuery } from '@tanstack/react-query';
import useApiStore from '../../store/useApiStore';
import { ILoanOfficer } from '../../types';
import { LOAN_OFFICERS } from '../../utils/constants';
import Api from '../Api';

export default function useGetLoanOfficers() {
  const { onError } = useApiStore();

  return useQuery<ILoanOfficer[], Error>({
    queryKey: [LOAN_OFFICERS],
    queryFn: async () => {
      const api = new Api({ onError });

      const data: ILoanOfficer[] = await api.get({
        url: 'api/v1/campaigns/loan-officers',
      });

      return data;
    },
  });
}
